import { Component, Input, HostBinding, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'checklist-item',
  template: require('./checklist-item.component.html'),
  styles: [require('./checklist-item.component.scss')],
})
export class ChecklistItemComponent {
  @Input() item: string;
  @Output() onSelectItem: EventEmitter<string> = new EventEmitter<string>();

  @HostBinding('class.is-selected') private selected: boolean = false;

  @HostListener('click', ['$event'])
  onClick(): void {
    this.selected = !this.selected;
    this.onSelectItem.emit(this.item);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/checklist-item/checklist-item.component.ts